"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountClick = void 0;
const enums_1 = require("../enums");
const trackAnalyticsEvent_1 = require("./trackAnalyticsEvent");
function trackCustomerAccountClick(clickType, eventLabel, eventData) {
    if (clickType && eventLabel) {
        (0, trackAnalyticsEvent_1.trackAnalyticsEvent)({
            category: enums_1.EventCategory.Header,
            action: clickType,
            label: eventLabel,
            nonInteraction: false,
            ...(eventData ? { eventData } : undefined),
        });
    }
}
exports.trackCustomerAccountClick = trackCustomerAccountClick;
//# sourceMappingURL=trackCustomerAccountClick.js.map